// 活動小獎
import Image from 'next/image';

const CampaignMinorPrize = ({ prize }) => {
    return (
        <div
            className="p-[20px] w-[calc((100%-16px)/2)] flex-shrink rounded-[12px] border-1 border-[#fff] border-opacity-[.3] bg-[rgb(128,128,128)] bg-opacity-[.16] backdrop-blur-[15px]
            flex items-center gap-x-[20px] ulg:py-[10px] umd:!py-[20px]"
        >
            {/* 獎品圖 */}
            <div
                className="img-box w-[113px] aspect-[1/1] rounded-[6px] flex-shrink-0 after:content-none
            ulg:w-[78px] umd:!w-[113px]"
            >
                <Image width={110} height={110} src={prize?.image} alt={prize?.name} />
            </div>

            <div className="space-y-[20px]">
                {/* 獎品名稱 */}
                <p className="text-btn3b text-white line-clamp-2 umd:line-clamp-3 uxs:line-clamp-[unset]">
                    {prize?.name}
                </p>

                {/* 獎品數量 */}
                <p className="text-btn1 text-[#c7c7c7]">{prize?.desc}</p>
            </div>
        </div>
    );
};

export default CampaignMinorPrize;
